import React from 'react';

import { Box, Grid, Typography, useTheme } from '@mui/material';

import useMediaQuery from '@mui/material/useMediaQuery';
import parse from 'html-react-parser';
import BgVideo from '../../../assets/video/nations.mp4';
import StyledWhoIsJadeSoft from './styles';

import Cambodia from '../../../assets/images/solution/flags/Cambodia.png';
import China from '../../../assets/images/solution/flags/China.png';
import India from '../../../assets/images/solution/flags/India.png';
import Indonesia from '../../../assets/images/solution/flags/Indonesia.png';
import Japan from '../../../assets/images/solution/flags/Japan.png';
import Korea from '../../../assets/images/solution/flags/Korea.png';
import Malaysia from '../../../assets/images/solution/flags/Malaysia.png';
import Mexico from '../../../assets/images/solution/flags/Mexico.png';
import Myanmar from '../../../assets/images/solution/flags/Myanmar.png';
import Thailand from '../../../assets/images/solution/flags/Thailand.png';
import Vietnam from '../../../assets/images/solution/flags/Vietnam.png';

import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import { TypeAnimation } from 'react-type-animation';

const WhoIsJadeSoft = () => {
    const theme = useTheme();
    const location = useLocation();
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const label = t('market-label-one');
    const labelMobile = t('market-label-one');
    const row = [
        {
            id: 1,
            title: 'Korea',
            image: Korea,
        },
        {
            id: 2,
            title: 'Malaysia',
            image: Malaysia,
        },
        {
            id: 3,
            title: 'Myanmar',
            image: Myanmar,
        },
        {
            id: 4,
            title: 'Thailand',
            image: Thailand,
        },
        {
            id: 5,
            title: 'Vietnam',
            image: Vietnam,
        },
        {
            id: 6,
            title: 'China',
            image: China,
        },
        {
            id: 7,
            title: 'Cambodia',
            image: Cambodia,
        },
        {
            id: 8,
            title: 'India',
            image: India,
        },
        {
            id: 9,
            title: 'Indonesia',
            image: Indonesia,
        },
        {
            id: 10,
            title: 'Japan',
            image: Japan,
        },
        {
            id: 11,
            title: 'Mexico',
            image: Mexico,
        },
    ];
    let videoClass = location.pathname === '/turnkey' ? 'videoElementGap' : 'videoElement';
    return (
        <StyledWhoIsJadeSoft>
            <Box className="mainContainer">
                {/* <Box
                        sx={{
                            height: '20px',
                            [theme.breakpoints.down('lg')]: {
                                display: 'none !important',
                            },
                        }}
                    ></Box> */}
                <Box
                    className="homeBg"
                    sx={{
                        [theme.breakpoints.down('lg')]: {
                            width: '400px',
                            height: '440px',
                        },
                    }}
                >
                    <video width="100%" autoPlay loop muted playsInline className={videoClass}>
                        <source src={BgVideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </Box>
                <Box
                    className="homeContent"
                    sx={{
                        [theme.breakpoints.down('lg')]: {
                            width: '400px',
                            height: '440px',
                        },
                    }}
                >
                    <Box sx={{ textAlign: { xs: 'center', md: 'center' }, zIndex: 1, width: '100%', justifyContent: 'center', alignItems: 'center' }}>


                        <Grid
                            container
                            className='text-overlay'
                            sx={{
                                marginLeft: '600px',
                                marginTop: '100px',
                                // padding: '0 40%',
                                lineHeight: '47.73px',
                                display: 'flex',
                                textAlign: 'center',
                                [theme.breakpoints.down('lg')]: {
                                    marginTop: 'unset',
                                },
                            }}
                        >
                            <Grid item>
                                <Typography
                                    variant="h2"
                                    component="h2"
                                    sx={{
                                        fontSize: '48px',
                                        fontWeight: '800',
                                        mb: 8,
                                        [theme.breakpoints.down('lg')]: {
                                            fontSize: '40px',
                                            lineHeight: '47.73px',
                                            display: 'none',
                                        },
                                    }}
                                >
                                    {t('whois-label-one') + parse('&nbsp')}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography
                                    variant="h2"
                                    component="h2"
                                    sx={{
                                        fontSize: '48px',
                                        fontWeight: '800',
                                        mb: 8,
                                        [theme.breakpoints.down('lg')]: {
                                            fontSize: '40px',
                                            lineHeight: '47.73px',
                                            display: 'none',
                                        },
                                    }}
                                >
                                    <TypeAnimation
                                        preRenderFirstString={true}
                                        sequence={[
                                            // Same substring at the start will only be typed once, initially
                                            'KOREA',
                                            1000,
                                            'THAILAND',
                                            1000,
                                            'INDONESIA',
                                            1000,
                                            'JAPAN',
                                            1000,
                                            'MALAYSIA',
                                            1000,
                                            'BRAZIL',
                                            1000,
                                            'VIETNAM',
                                            1000,
                                            'CHINA',
                                            1000,
                                            'ARGENTINA',
                                            1000,
                                        ]}
                                        speed={50}
                                        // deletionSpeed={50}
                                        // style={{ fontSize: '2em' }}
                                        // speed={{ type: 'keyStrokeDelayInMs', value: 250 }}
                                        // deletionSpeed={{ type: 'keyStrokeDelayInMs', value: 250 }}
                                        repeat={Infinity}
                                    />
                                </Typography>
                            </Grid>
                        </Grid>
                        <Typography
                            variant="h2"
                            component="h2"
                            sx={{
                                fontSize: '48px',
                                fontWeight: '800',
                                mt: 8,
                                display: 'none',
                                [theme.breakpoints.down('lg')]: {
                                    fontSize: '50px',
                                    lineHeight: '59.67px',
                                    display: 'flex',
                                    textAlign: 'center',
                                    justifyContent: 'center',
                                },
                            }}
                        >
                            {parse('JADE SOFT')}
                        </Typography>
                        <Grid height={'80px'}>
                            <Typography
                                variant="h2"
                                component="h2"
                                sx={{
                                    fontSize: '48px',
                                    fontWeight: '800',
                                    mb: 5,
                                    display: 'none',
                                    [theme.breakpoints.down('lg')]: {
                                        fontSize: '40px',
                                        lineHeight: '47.73px',
                                        display: 'flex',
                                        textAlign: 'center',
                                        justifyContent: 'center',
                                    },
                                }}
                            >
                                <TypeAnimation
                                    preRenderFirstString={true}
                                    sequence={[
                                        // Same substring at the start will only be typed once, initially
                                        'KOREA',
                                        1000,
                                        'THAILAND',
                                        1000,
                                        'INDONESIA',
                                        1000,
                                        'JAPAN',
                                        1000,
                                        'MALAYSIA',
                                        1000,
                                        'BRAZIL',
                                        1000,
                                        'VIETNAM',
                                        1000,
                                        'CHINA',
                                        1000,
                                        'ARGENTINA',
                                        1000,
                                    ]}
                                    speed={50}
                                    // deletionSpeed={50}
                                    // style={{ fontSize: '2em' }}
                                    // speed={{ type: 'keyStrokeDelayInMs', value: 250 }}
                                    // deletionSpeed={{ type: 'keyStrokeDelayInMs', value: 250 }}
                                    repeat={Infinity}
                                    cursor={false}
                                />
                            </Typography>
                        </Grid>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ textAlign: { xs: 'center', md: 'center' }, zIndex: 1 }} className="content">
                <Box>
                    <Typography
                        variant="body1"
                        sx={{
                            mb: 12,
                            mt: 6,
                            // lineHeight: 1.8,
                            fontSize: '20px',
                            fontWeight: 700,
                            lineHeight: '26px',
                            padding: localStorage.getItem('i18nextLng') === 'en-US' ? '0px 100px' : 'unset',
                            [theme.breakpoints.down('lg')]: {
                                padding: '30px 20px',
                            },
                        }}
                    >
                        {!isMobile ? parse(label) : parse(labelMobile)}
                    </Typography>
                </Box>
                <Box
                    mt={5}
                    // mb={10}
                    px={40}
                    display={'flex'}
                    justifyContent={'center'}
                    sx={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        color: '#000000',
                        [theme.breakpoints.down('lg')]: {
                            px: 0,
                            mb: 6,
                        },
                    }}
                >
                    <Grid container justifyContent="center" rowSpacing={{ xs: 7, sm: 7, md: 7, lg: 0, xl: 0 }}>
                        {row.map((item, index) => (
                            <Grid item xs={4} sm={4} md={4} lg={2} xl={2} key={index} display="flex" justifyContent="center">
                                <Box sx={{ maxWidth: '100%', maxHeight: '100%', mb: 5 }} display={'flex'} key={item.id}>
                                    <Box
                                        sx={{
                                            // backgroundColor: '#ffffff',
                                            textAlign: 'center',
                                            maxHeight: '100%',
                                            [theme.breakpoints.down('lg')]: {
                                                width: '65px !important',
                                                height: '65.92px !important',
                                            },
                                        }}
                                    >
                                        <Box
                                            // px={12}
                                            sx={{
                                                marginBottom: 5,
                                                [theme.breakpoints.down('lg')]: {
                                                    width: '65px !important',
                                                    height: '65.92px !important',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    textAlign: 'center',
                                                    justifySelf: 'center',
                                                    px: 0,
                                                },
                                            }}
                                        >
                                            <img
                                                src={item.image}
                                                style={{
                                                    maxWidth: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                }}
                                            />
                                        </Box>
                                        <Box
                                            display={'flex'}
                                            justifyContent={'center'}
                                            px={8}
                                            sx={{
                                                [theme.breakpoints.down('lg')]: {
                                                    px: 0,
                                                },
                                            }}
                                        >
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    mt: 2,
                                                    mb: 5,
                                                    lineHeight: '26.67px',
                                                    wordWrap: 'break-word',
                                                    fontWeight: '900 !important',
                                                    fontSize: '18.7px',
                                                    color: '#676767 !important',
                                                    [theme.breakpoints.down('lg')]: {
                                                        mt: 1,
                                                        fontSize: '30px',
                                                        lineHeight: '35.8px',
                                                    },
                                                }}
                                            >
                                                {item.title}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>
        </StyledWhoIsJadeSoft >
    );
};

export default WhoIsJadeSoft;
